import { CONV_STORAGE, Video, onStage, spacesView, volumeManager } from "../../../libs/roomnew";

export const volumeHandleLocalParticipantSpaceChange=(space,oldSpace)=>{
    if(space){
        //local participant joined a space
        space.setVolume(1);
        volumeManager.resetSpacesVolumes(space.id);
    }else{
        //local participant joined lobby
        onStage.isActive() || spacesView.setVolume(1);
        volumeManager.resetSpacesVolumes('lobby');
    }
}
export const volumeHandleRemoteParticipantSpaceChange=(participant,space,oldSpace)=>{
    const mySpaceId = CONV_STORAGE.myConversation;
    if(!space && !mySpaceId){
        //joined lobby with local participant
        const volume = !onStage.isActive() || onStage.participants.includes(p.id) ? 1 : spacesView.volume;
        participant.setVolume(volume,true)
        if(Video.lockMasterVolume.isLocked()){
            Video.addEnabledVolumeControl(participant.id);
        }
    }else if(space && space.id === mySpaceId){
        //joined my space
        participant.setVolume(space.volume,true)
        if(Video.lockMasterVolume.isLocked()){
            Video.addEnabledVolumeControl(participant.id);
        }
    }else{
        //joined other space
        const volume = space ? space.volume : spacesView.volume;
        participant.setVolume(volume,true);
        if(Video.lockMasterVolume.isLocked()){
            Video.addDisabledVolumeControl(participant.id);
        }
    }
}


export const handleSpaceMenuUpdate=(space, oldSpace)=>{
    console.log(`Spaces panel is open ${spacesView.isOpen()}, new space`,space,"old space",oldSpace)
    if(spacesView.isOpen()){
        try {
            if(!$("#dropDownMenu").hasClass("d-none")){
                if(!space || !oldSpace){
                    spacesView.createDropDownMenuOptions();
                }
                Video.efss.inViewportSpaceMenu(false);
            }

            if(space && !$(`#dropDownMenuOption-${space.id}`).hasClass("d-none")){
                space.createDropDownMenuOptions()
            }
            if(oldSpace && !$(`#dropDownMenuOption-${oldSpace.id}`).hasClass("d-none")){
                oldSpace.createDropDownMenuOptions()
            }

        } catch (error) {
            console.error(error)
        }
    }else{
        if($("#left-space-menu").hasClass("open")){
            const openSpaceId = $("#left-space-menu").attr("space-id");
            if(openSpaceId == "lobby"){
                if(!space || !oldSpace){
                    spacesView.renderLeftMenuParticipants();
                }
            }else if(openSpaceId){
                if(space?.id == openSpaceId){
                    space.renderLeftMenuParticipants()
                }
                if(oldSpace?.id == openSpaceId){
                    oldSpace.renderLeftMenuParticipants()
                }
            }
            Video.efss.inViewportSpaceMenu(false);
        }
    }
}
